<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-04 10:55:22
 * @Description: 账号激活 信息校验
-->
<template>
	<div>
		<a-form-model ref="form" :model="form" :rules="rules" :wrapper-col="wrapperCol">
			<a-form-model-item label="" prop="username">
				<a-input
					v-model="form.username"
					:placeholder="`${$t('login.username_placeholder')}${basicSetInfo.sfzjh == 1 ? `/${$t('login.activate.offer_placeholder')}` : ''}`"
				/>
			</a-form-model-item>
			<a-form-model-item label="" prop="displayName">
				<a-input v-model="form.displayName" :placeholder="$t('login.activate.name_placeholder')" />
			</a-form-model-item>
			<a-form-model-item label="" prop="idType">
				<a-select v-model="form.idType">
					<a-select-option value="1">{{ $t("base.idCard") }}</a-select-option>
					<a-select-option value="2">{{ $t("base.passport") }}</a-select-option>
					<a-select-option value="3">{{ $t("base.gatCard") }}</a-select-option>
					<a-select-option value="4">{{ $t("base.other") }}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="" prop="idCardNo">
				<a-input v-model="form.idCardNo" :placeholder="$t('login.activate.card_id')" />
			</a-form-model-item>
			<a-form-model-item label="" prop="captcha">
				<div class="valid-mask">
					<a-input v-model="form.captcha" :placeholder="$t('base.captcha.placeholder')" />
					<img class="valid-mask-img" :src="validMaskImage" alt="" @click="getValidMask" />
				</div>
			</a-form-model-item>
		</a-form-model>

		<div class="next">
			<a-button style="width: 440px" type="primary" @click="handleNext">{{ $t("base.btn.next_step") }}</a-button>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";

export default {
	props: {
		basicSetInfo: { type: Object, default: () => {} },
	},
	data() {
		return {
			wrapperCol: { span: 18, offset: 3 },
			form: { idType: "1", captchaKey: "" },
			rules: {
				username: [
					{
						required: true,
						message: `${this.$t("login.username_placeholder")}${
							this.basicSetInfo.sfzjh == 1 ? `/${this.$t("login.activate.offer_placeholder")}` : ""
						}`,
					},
				],
				displayName: [{ required: true, message: this.$t("login.activate.name_placeholder") }],
				idType: [{ required: true, message: this.$t("login.activate.card_type_placeholder") }],
				idCardNo: [{ required: true, message: this.$t("login.activate.card_id") }],
				captcha: [{ required: true, message: this.$t("base.captcha.placeholder") }],
			},
			validMaskImage: "", // 验证码
		};
	},
	created() {
		this.getValidMask();
	},
	methods: {
		// 得到验证码图片
		async getValidMask() {
			const { code, data } = await commonAPI.getAction("/user/active/captcha");
			if (code === 0) {
				this.validMaskImage = data.image;
				this.form.captchaKey = data.captchaKey;
			}
		},
		// 下一步
		handleNext() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.handleNextApi();
				} else {
					return false;
				}
			});
		},
		async handleNextApi() {
			let params = { ...this.form };
			const { code, data, message } = await commonAPI.postAction("/user/active/checkUserInfo", params);
			if (code == 0) {
				let obj = { username: this.form.username, secretKey: data };
				localStorage.setItem("ACTIVATE_INFO", JSON.stringify(obj));
				this.$message.success(message);
				this.$emit("next", 1);
			} else {
				this.getValidMask();
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.next {
	padding-top: 20px;
	text-align: center;
}
.valid-mask {
	display: flex;
	justify-content: space-between;
	align-items: center;
	::v-deep .ant-input {
		width: calc(100% - 110px);
	}
	.valid-mask-img {
		width: 100px;
		height: 32px;
		cursor: pointer;
	}
}
</style>
